<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">审查调查></span>
        <span @click="GoreportEvaluation">党纪政务处分></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>黑龙江省哈尔滨市政协原党组书记、主席姜国文严重违纪违法被开除党籍和公职</h1>
        <div class="first">
          <span class="third">来源：新华社</span>
            <span class="si">|</span>
          <span>发布时间：2020-5-20 13:30</span>
        </div>
         <div class="xh"></div>
        <h3 class="yi">日前，经中共中央批准，中央纪委国家监委对黑龙江省哈尔滨市政协原党组书记、主席姜国文严重违纪违法问题进行了立案审查调查。,把信访举报作为纪律审查的线索的第一来源渠道，充分发挥其“预警器”和“晴雨表”作用，注重精准分析，提高办信质效，积极探索化解基层信访问题的新途径、新办法，不断推进信访举报工作高质量发展。</h3>
        <h3>经查，姜国文丧失对党的领导和中国特色社会主义的信仰、信念，对党不忠诚不老实，搞两面派、做两面人，对抗组织审查；违反中央八项规定精神，违规出入私人会所；不按规定报告个人有关事项，在组织谈话函询时不如实说明问题；与不法商人沆瀣一气，搞权钱交易、权色交易，违规从事营利活动，收受礼金；在监督执纪过程中失责弃守、执纪违纪、执法犯法，将公权力变为谋取私利的工具，在职务晋升、工程承揽、企业经营等方面为他人谋取利益，并非法收受巨额财物，严重损害纪检监察机关和干部的形象，严重破坏所任职地区的政治生态。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>姜国文严重违反党的政治纪律、组织纪律、廉洁纪律和生活纪律，构成严重职务违法并涉嫌受贿犯罪，且在党的十八大后不收敛不收手，性质严重，影响恶劣，应予严肃处理。依据《中国共产党纪律处分条例》《中华人民共和国监察法》等有关规定，经中央纪委常委会会议研究并报中共中央批准，决定给予姜国文开除党籍处分；由国家监委给予其开除公职处分；终止其黑龙江省第十二次党代会代表资格；收缴其违纪违法所得；将其涉嫌犯罪问题移送检察机关依法审查起诉，所涉财物随案移送。-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>
          <b>姜国文简历</b>
        </h3>
        <h3>姜国文，男，1957年9月出生，汉族，黑龙江克山人，1975年7月参加工作，1980年8月加入中国共产党，黑龙江省委党校经济管理专业在职研究生毕业，法学学士。</h3>
        <h3>1975.07—1978.03 黑龙江省克山县河南公社知青</h3>
        <h3>1978.03—1980.09 黑龙江机械制造学校钢铁铸造专业学习</h3>
        <h3>1980.09—1981.10 黑龙江省外运公司驻大连办业务员</h3>
        <h3>1981.10—1982.11 黑龙江省轻工进出口公司驻大连办业务员</h3>

        <h3>1982.11—1984.11 黑龙江省轻工进出口公司副科长</h3>
        <h3>1984.11—1989.07 黑龙江省轻工进出口公司科长</h3>
        <h3>（1984.05—1986.11黑龙江大学党政干部基础科学习）</h3>
        <h3>1989.07—1989.10 黑龙江省经贸厅政工处科长</h3>
        <h3>1989.10—1992.10 黑龙江省经贸厅政工处、人事教育处副处长</h3>
        <h3>1992.10—1996.05 黑龙江省经贸委人事处处长</h3>
        <h3>1996.05—1996.11 黑龙江省对外贸易经济合作厅人事劳资处处长</h3>
        <h3>1996.11—2003.06 黑龙江省对外贸易经济合作厅副厅长、党组成员</h3>
        <h3>2003.06—2003.12 黑龙江省政府副秘书长</h3>
        <h3>2003.12—2006.12 黑龙江省政府副秘书长（正厅级）</h3>
        <h3>（2003.03—2005.07中国政法大学法学专业在职本科学习，获法学学士学位）</h3>
        <h3>2006.12—2012.01 中共哈尔滨市委常委、纪委书记</h3>
        <h3>（2005.03—2008.01黑龙江省委党校经济管理专业在职研究生学习；2009.03—2009.07中央党校第二十六期中青年干部培训班学习）</h3>
        <h3>2012.01—2016.01 中共哈尔滨市委副书记，市纪委书记</h3>
        <h3>2016.01 哈尔滨市政协主席、党组书记（简历摘自政协哈尔滨市委员会网站）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/Investigate");
    },
    GoreportEvaluation() {
      this.$router.push("/Investigate/DangJi" );
    },
  }
};
</script>

<style lang="less" scoped>
.si{
   margin: 0 16px;
 }
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
}
.yi {
  margin-top: 20px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
</style>